import React from 'react';
import { css } from '@emotion/react';
import { Link } from 'react-router';
import { blocks } from '@birdi/theme';
import LogoSVG from '@birdi/icons/birdi-logo-navy.svg';

export const EquipmentHeader = ({ children }) => (
  <header css={blocks.contextualHeader}>
    <Link
      to="/"
      css={css`
        padding: 0;
        margin-right: auto;
      `}
    >
      <LogoSVG
        css={css`
          width: 3em;
          height: 3em;
        `}
      />
    </Link>
    <div
      css={css`
        cursor: pointer;
        display: flex;
        & > * {
          margin-left: 0.5rem;
        }
      `}
    >
      {children}
    </div>
  </header>
);
